export default {
  iddescarganf: 0,
  idcliente: 0,
  idposto: 0,
  idproduto: 0,
  cnpjdistribuidoradescarganf: '',
  cnpjtransportadoradescarganf: '',
  idusuario: 0,
  datahoradescarganf: null,
  datahorainiciodescarganf: null,
  datahorafimdescarganf: null,
  datadadosnfdescarganf: null,
  datacapturainiciodescarganf: null,
  datacapturafimdescarganf: null,
  numeropedidodescarganf: '',
  nfdescarganf: '',
  dataemissaonfdescarganf: null,
  placactdescarganf: '',
  motoristadescarganf: '',
  volumenfdescarganf: 0.0,
  precounitariodescarganf: 0.0,
  precototaldescarganf: 0.0,

  temperaturaamostratbdescarganf: 0.0,
  densidadeambienteamostratbdescarganf: 0.0,

  densidade20tbdescarganf: 0.0,
  temperaturanftbdescarganf: 0.0,
  densidade20nftbdescarganf: 0.0,
  volume20nftbdescarganf: 0.0,

  finalizadadescarganf: 0,
  compartimentos: [],
  tanques: [],

  inspecao: {
    iddescarganfinspecao: null,
    idcliente: null,
    idposto: null,
    iddescarganf: null,
    inpsdataentradabdescarganfinspecao: null,
    inpsdatasaidabdescarganfinspecao: null,
    inpslacresconferemdescarganfinspecao: 'N',
    inspprodutosetadescarganfinspecao: 'N',
    inpsisentoaguaimpurezadescarganfinspecao: 'N',
    inpsvisualprodutodescarganfinspecao: 'NOK',
    inpscompartimentovaziodescarganfinspecao: 'S',
    idusuario: null,
  },

  compartimentoamostradescarganf: 0,
  densidade20amostradescarganf: 0.0,
  numerocompartimentosdescarganf: 0,
  modorecebimentodescarganf: null,

  tokenuuiddescarganf: '',
  jatiroufotodescarganf: 'N',

  comnfedescarganf: 'N',
  idusuariodescargaacimacapacidadedescarganf: null,
  obsdescargaacimacapacidadedescarganf: '',
  excedecapacidadeinicio: null,
};
